// Mapping des icônes lucide-react pour chaque section
// Utilisation: import { iconsMapping, getIcon } from './files/iconsMapping';
// Puis: iconsMapping.Trail, iconsMapping['Courses des enfants'], etc.
// Ou: getIcon('Trail'), getIcon('Courses des enfants')

import {
  Mountain,
  Trophy,
  Footprints,
  Award,
  HeartHandshake,
  Handshake,
  Users,
  Home,
  Palette,
  Music,
  Video
} from 'lucide-react';

export const iconsMapping = {
  'Trail': 'Mountain',
  'Courses des enfants': 'Trophy',
  'Marches': 'Footprints',
  'Podiums': 'Award',
  'Bénévoles': 'HeartHandshake',
  'Partenaires': 'Handshake',
  'Associations': 'Users',
  'Village': 'Home',
  'Ateliers enfants': 'Palette',
  'Concerts': 'Music',
  'Vidéos': 'Video'
};

// Objet mappant les noms des icônes à leurs composants
const iconComponents = {
  'Mountain': Mountain,
  'Trophy': Trophy,
  'Footprints': Footprints,
  'Award': Award,
  'HeartHandshake': HeartHandshake,
  'Handshake': Handshake,
  'Users': Users,
  'Home': Home,
  'Palette': Palette,
  'Music': Music,
  'Video': Video
};

/**
 * Retourne le composant d'icône correspondant au nom de la section
 * @param {string} sectionName - Le nom de la section (ex: 'Trail', 'Concerts', etc.)
 * @param {number} size - Taille de l'icône (par défaut 24)
 * @returns {React.Component} Le composant d'icône ou null si non trouvé
 */
export const getIcon = (sectionName, size = 24) => {
  const iconName = iconsMapping[sectionName];
  const IconComponent = iconName ? iconComponents[iconName] : null;
  
  if (!IconComponent) {
    console.warn(`Icône non trouvée pour: ${sectionName}`);
    return null;
  }
  
  return <IconComponent size={size} />;
};

/**
 * Retourne uniquement le composant d'icône sans JSX
 * @param {string} sectionName - Le nom de la section
 * @returns {React.Component} Le composant d'icône ou null
 */
export const getIconComponent = (sectionName) => {
  const iconName = iconsMapping[sectionName];
  return iconName ? iconComponents[iconName] : null;
};

// Import recommandé:
// import { getIcon, getIconComponent, iconsMapping } from './files/iconsMapping';
//
// Utilisation:
// {getIcon('Trail')}
// {getIcon('Concerts', 32)}
//
// Ou pour avoir le composant:
// const IconComp = getIconComponent('Trail');
// <IconComp size={24} />
